import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export default api;

export const PROJECT_STATUSES = [
  "New Lead",
  "Mockup Needed",
  "Quote Sent",
  "Approved",
  "In Production",
  "Installed",
  "Lost",
];

export const SIGN_TYPES = [
  "Front Lit Channel Letters",
  "Reverse Halo Lit Channel Letters",
  "Front Lit + Halo Lit",
  "Raceway Mounted",
  "Flush Mounted",
  "Cabinet Sign",
  "Monument Sign",
  "Blade Sign",
  "Vinyl Window Graphics",
  "Other",
];

export const FONT_OPTIONS = [
  { id: "Inter", label: "Sans Serif", css: "'Inter', 'Manrope', sans-serif" },
  { id: "Georgia", label: "Serif", css: "Georgia, 'Times New Roman', serif" },
  { id: "Impact", label: "Bold Block", css: "Impact, 'Arial Black', sans-serif" },
  { id: "Brush", label: "Script", css: "'Brush Script MT', cursive" },
  { id: "Cabinet", label: "Modern", css: "'Cabinet Grotesk', sans-serif" },
  { id: "Quicksand", label: "Rounded", css: "'Quicksand', 'Manrope', sans-serif" },
];

export const PRESET_COLORS = [
  "#FFFFFF", "#000000", "#EF4444", "#3B82F6",
  "#10B981", "#F59E0B", "#F97316", "#A855F7",
];

export function statusTone(status) {
  switch (status) {
    case "New Lead": return "text-zinc-300 border-zinc-700 bg-zinc-900/40";
    case "Mockup Needed": return "text-amber-300 border-amber-700/60 bg-amber-950/30";
    case "Quote Sent": return "text-blue-300 border-blue-700/60 bg-blue-950/30";
    case "Approved": return "text-emerald-300 border-emerald-700/60 bg-emerald-950/30";
    case "In Production": return "text-orange-300 border-orange-700/60 bg-orange-950/30";
    case "Installed": return "text-cyan-300 border-cyan-700/60 bg-cyan-950/30";
    case "Lost": return "text-rose-300 border-rose-800/60 bg-rose-950/30";
    default: return "text-zinc-300 border-zinc-700 bg-zinc-900/40";
  }
}
